import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const useStaticPartsTypesQuery = () => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'staticPartsTypes',
    params: [],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('staticPartsListTypes')
        .extras({errorDetails})
        .error('Error occurred while fetching drilling settings')

      spawnErrorToast(t('error.staticPartsTypes'))

      return false
    }
  })
}
